import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, typography, spacing, radius, focusVisible } from '@/styles/designTokens'

export const ActionsFooterRoot = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: spacing.xl,
	padding: spacing.xl,
	backgroundColor: colors.surfaceWhite,
	borderTop: `1px solid ${colors.divider}`,
	flexShrink: 0,
})

export const OrderDetailsRow = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: spacing.lg,
	width: '100%',
})

export const OrderDetailsPairs = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	gap: spacing.sm,
	flex: '1 0 0',
	minWidth: 0,
})

export const OrderDetailsPair = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: spacing.sm,
	flexShrink: 0,
})

export const TimingPair = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	gap: spacing.xs,
	flex: '1 0 0',
	minWidth: 0,
})

export const OrderTypeLabel = styled('span')({
	fontSize: typography.fontSizeMd,
	fontWeight: typography.fontWeightBold,
	lineHeight: typography.lineHeightMd,
	letterSpacing: typography.letterSpacingWide,
	color: colors.textPrimary,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
})

export const TimingText = styled('span')({
	fontSize: typography.fontSizeMd,
	fontWeight: typography.fontWeightRegular,
	lineHeight: typography.lineHeightMd,
	letterSpacing: typography.letterSpacingWide,
	color: colors.textPrimary,
})

export const TimingBold = styled('span')({
	fontWeight: typography.fontWeightBold,
})

export const EditIconButton = styled('button')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 20,
	height: 20,
	padding: 0,
	background: 'none',
	border: 'none',
	cursor: 'pointer',
	color: colors.textPrimary,
	fontFamily: 'inherit',
	flexShrink: 0,
	'&:focus-visible': {
		outline: `${focusVisible.outline} ${colors.brand}`,
		outlineOffset: focusVisible.outlineOffset,
		borderRadius: radius.badge,
	},
})
